import { useCallback, useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import api from '../../../api'
import Responsive from '../../../assets/config/Responsive'
import Colors from '../../../assets/styles/Colors'
import Loader from '../../../components/Loader'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import CompanySelect from '../../../components/v2/CompanySelect'
import HorizontalCard from '../../../components/v2/HorizontalCard'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import Title from '../../../components/v2/Title'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import TplProgressbar from '../../../components/v2/progrees-bars/TplProgressbar'
import { TplCompareRequest } from '../../../domain/types'
import { useAppDispatch, useAppSelector } from '../../../store'
import { AppState } from '../../../store/appSlice'
import { TplState, setChooseMethod, setIncomeCompanies, setOffer, setSelectedCompanies } from '../../../store/tplSlice'

const WhichMethod = () => {
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const { data: tplChoise, isLoading: isTplChoiseLoading } = api.useGetTplChoiseQuery(undefined)
  //
  const pageTitle = tplChoise?.translations[lang]?.title
  const stepName = tplChoise?.translations[lang]?.stepName
  //
  const listItems = tplChoise?.listItems.slice().sort((a, b) => a.sort - b.sort)
  //
  const { t } = useTranslation()
  //
  const dispatch = useAppDispatch()
  //
  const { filter, screenHeader } = useAppSelector((data: { tpl: TplState }) => data.tpl)
  //
  const navigate = useNavigate()
  //
  //
  const query = `ProductCategorySlug=${filter.productCategory}&StartDate=${filter.dates?.start}&EndDate=${
    filter.dates?.end
  }&Currency=${filter.currency?.toUpperCase()}&Limit=${filter.limit}&PackageServiceIds=${filter.selectedServices}`
  //
  //
  const { data: tplLeftCompanies, isLoading: tplLeftCompanyLoading } = api.useGetTplLeftCompaniesQuery(
    {
      stepName: 'four',
      query: query,
    },
    {
      skip: filter.selectedServices && filter.selectedServices.length >= 1 ? false : true,
      refetchOnMountOrArgChange: true,
    },
  )
  //
  //
  const watchAndSetCompanies = useCallback(() => {
    //
    if (tplLeftCompanies && tplLeftCompanies.companies && tplLeftCompanies.companies.length >= 1) {
      dispatch(setIncomeCompanies(tplLeftCompanies.companies as never))
    }
    //
  }, [tplLeftCompanies, dispatch])
  //
  //
  // set companies in store
  useEffect(() => {
    watchAndSetCompanies()
    //
    return () => {}
  }, [watchAndSetCompanies])
  //
  // @ts-ignore
  const SelectedCompanyArray: TplState['filter']['selectedCompanies'] = filter.selectedCompanies?.map((x) => x.id)
  //
  // selected companies
  const matchingObjects = filter.incomeCompanies?.filter((obj) => SelectedCompanyArray?.includes(obj.id as never))
  //
  //
  // auto clear selected companies
  useEffect(() => {
    dispatch(setSelectedCompanies([]))

    return () => {}
  }, [dispatch])
  //
  //
  // auto navigate first page
  useEffect(() => {
    if (!filter.dates?.start) {
      navigate('/tpl-choose-days')
    }
    //
    return () => {}
  }, [filter.dates?.start, navigate])
  //
  //
  const mainLoading = isTplChoiseLoading || tplLeftCompanyLoading
  //
  //
  return mainLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageTitle} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />

      <Content>
        <Title text={pageTitle} />

        <TplProgressbar stepName={stepName} />

        <Block>
          {listItems?.map((item, index) => {
            return (
              <HorizontalCard
                className="horizontal-card"
                key={index}
                disabled={false}
                title={item?.title}
                description={item?.body}
                imgUrl={item?.image}
                selected={item.type === filter.chooseMethod ? true : false}
                onClick={() => [dispatch(setChooseMethod(item.type)), dispatch(setOffer(undefined))]}
              >
                {/*change filter choosemethod*/}
                {item.type === filter.chooseMethod && filter.chooseMethod === 'my-choice' ? (
                  <Inner>
                    <hr />
                    <CompanyTitle>{item.translations?.[lang]?.title}</CompanyTitle>
                    <CompanyDescription>{item.translations?.[lang]?.body}</CompanyDescription>

                    <CompanySelect
                      closeMenuOnSelect={false}
                      onChange={(data) => {
                        const companies: TplCompareRequest['companies'] = data.map((item: any) => ({
                          id: item.value,
                          currency: filter.currency,
                          limit: filter.limit,
                        }))
                        //
                        dispatch(setSelectedCompanies(companies))
                        //
                      }}
                      isMulti={true}
                      maxSelectLenght={3}
                      maxSelectText={`${t('companyCmpare')}`}
                      placeholder={t('selectCompanies')}
                      showOptionCheckbox={true}
                      value={matchingObjects?.map((s) => ({
                        label: s.brandName?.[lang]?.title,
                        value: s.id,
                        imgUrl: s.cover,
                      }))}
                      options={
                        filter.incomeCompanies?.map((item) => ({
                          value: item.id,
                          label: item.brandName?.[lang]?.title,
                          imgUrl: item.cover,
                        })) || []
                      }
                    />
                  </Inner>
                ) : null}
              </HorizontalCard>
            )
          })}
        </Block>

        <Buttons>
          <NavigationButton text={`${t('back')}`} buttonType="prev" onClick={() => navigate('/tpl-extra-services')} />
          <NavigationButton
            text={`${t('next')}`}
            buttonType="next"
            disabled={
              (filter.productCategory &&
                filter.currency &&
                filter.limit &&
                filter.selectedServices &&
                filter.selectedServices.length >= 1 &&
                filter.incomeCompanies &&
                filter.incomeCompanies.length >= 1 &&
                filter.chooseMethod === 'frani-choice') ||
              //
              (filter.productCategory &&
                filter.currency &&
                filter.limit &&
                filter.selectedServices &&
                filter.selectedServices.length >= 1 &&
                filter.incomeCompanies &&
                filter.incomeCompanies.length >= 1 &&
                filter.selectedCompanies &&
                filter.selectedCompanies.length >= 1 &&
                filter.chooseMethod === 'my-choice')
                ? false
                : true
            }
            onClick={() => {
              if (filter.chooseMethod === 'frani-choice') {
                return navigate('/tpl-offer')
              }
              //
              if (filter.chooseMethod === 'my-choice') {
                return navigate('/tpl-offers')
              }
            }}
          />
        </Buttons>
      </Content>

      <BackgroundIcon />
    </Wrapper>
  )
}
//
const CompanyTitle = styled.p`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  margin-bottom: 1px;
`
const CompanyDescription = styled.p`
  font-size: 14px;
  color: ${Colors.nevadaGrey};
  margin-bottom: 18px;
`
const Inner = styled.div`
  /*  */
`
const Block = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 32px;

  .horizontal-card {
    margin-bottom: 24px;
    &:last-child {
      margin-bottom: 0px;
    }
  }

  ${Responsive.mobile} {
    margin-top: 24px;

    .horizontal-card {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0px;
      }
    }
  }
`
const Buttons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-inline: auto;
  width: 100%;
  margin-top: 48px;
  max-width: 368px;

  button {
    width: 100%;
    padding-inline: 0px;
    &:first-child {
      margin-right: 20px;
    }
  }

  ${Responsive.mobile} {
    max-width: 296px;
    margin-top: 40px;
    button {
      &:first-child {
        margin-right: 15px;
      }
    }
  }
`
const Content = styled.div`
  margin-top: 58px;
  z-index: 2;
  padding-inline: 20px;

  ${Responsive.mobile} {
    margin-top: 26px;
  }
`
const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 20px;
  min-height: 100vh;
  /*  */
`
//
export default WhichMethod
